import { render, staticRenderFns } from "./PlushieViewPage.vue?vue&type=template&id=20ca7555&scoped=true&"
import script from "./PlushieViewPage.vue?vue&type=script&lang=ts&"
export * from "./PlushieViewPage.vue?vue&type=script&lang=ts&"
import style0 from "./PlushieViewPage.vue?vue&type=style&index=0&id=20ca7555&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ca7555",
  null
  
)

export default component.exports